/// <reference types="@types/googlemaps" /> // Don't remove this line!!! It isn't normal comment!

import {Component, OnInit} from '@angular/core';
import {StockApiService} from '../../../services/stock-api.service';
import {BasicFilter} from '../../../models/search/basic-filter';
import {AdvancedFilter} from '../../../models/search/advanced-filter';
import {Result} from '../../../models/search/result';
import {SearchModel} from '../../../models/searchModel';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {QueryStringService} from '../../../services/query-string.service';
import {BrandService} from '../../../services/brand.service';
import {AppComponent} from '../../../app.component';
import {LocalStorageService} from '../../../services/local-storage.service';
import {AdobeService} from '../../../services/adobe.service';
import {ErrorHandler} from '../../../tools/error-handler';
import {Brand, Brands} from '../../../models/Brands';
import {BlueKaiService} from '../../../services/blue-kai.service';
import {TitleService} from '../../../services/title.service';
import {LabelProviderService} from '../../../services/labelProvider.service';
import {TawkToChatService} from '../../../services/tawk-to-chat.service';

declare var google: any;
declare type GeocoderAddressComponent = google.maps.GeocoderAddressComponent;

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
})
export class ListComponent implements OnInit {

  basicFilters: BasicFilter = new BasicFilter();
  advancedFilters: AdvancedFilter = new AdvancedFilter();
  result: Result = new Result();
  resultListLoading = true;
  page = 1;
  sort = 'popular';
  dealerCode: string = null;
  openedFilters = false;
  pageLoadTime = null;
  bk_lastModel = undefined;
  newCarsOfferCount = null;
  initOfferCount: any = 'init';

  private idParamSubscription: Subscription;
  private goToHomepageSubscription: Subscription = null;


  constructor(
    private stockApiService: StockApiService,
    private route: ActivatedRoute,
    private QSS: QueryStringService,
    private LSS: LocalStorageService,
    private adobeService: AdobeService,
    private blueKaiService: BlueKaiService,
    private titleService: TitleService,
    private labelProviderService: LabelProviderService,
  ) {

    this.sort = QSS.getParam('sort') === null ? this.sort : QSS.getParam('sort') as string;
    this.page = QSS.getParam('page') === null ? this.page : +QSS.getParam('page');
    this.idParamSubscription = this.route.params.subscribe(params => {
      if (params['dealer_code']) {
        this.dealerCode = params['dealer_code'];
      }
      if (params['page']) {
        this.page = params['page'];
      }
      if (params['sort']) {
        this.sort = params['sort'];
      }
    });

    stockApiService.getBasicSearchData().then(value => {
      this.basicFilters = value;
    }).catch(reason => {
      ErrorHandler.handle(reason);
    });


    stockApiService.getNewCarsInfo().then(value => {
      this.newCarsOfferCount = value.currentBrand.offerCount;
    }).catch(reason => {
      ErrorHandler.handle(reason);
    });
  }

  ngOnInit() {
    this.adobeService.pageLoadHomepage(this.QSS.getParam('models'), this.QSS.getParam('cid'));
    this.pageLoadTime = new Date().getTime();

    setTimeout(() => {
      AppComponent.bodyClass = 'page page-offerts-list';
      TawkToChatService.enableTawkToChat(AppComponent.dealerCode, false);
    });
    this.idParamSubscription.unsubscribe();

    if (this.goToHomepageSubscription !== null) {
      this.goToHomepageSubscription.unsubscribe();
    }

    this.goToHomepageSubscription = AppComponent.goToHomepage.subscribe(() => {
      setTimeout(() => {
        this.pageLoadTime = new Date().getTime();
        this.onFilterUpdate(true);
      this.adobeService.pageLoadHomepage(this.QSS.getParam('models'), this.QSS.getParam('cid'));
      }, 100);
    });
  }

  onFilterUpdate(notSendTrackingData = false) {
    this.LSS.set('lfprop', this.QSS.getAllParams());
    this.beforeFilterUpdate();
    const filters = this.getFilters();

    const page = this.page;
    const sort = this.sort;
    if (this.QSS.getParam('place_id') !== null && this.QSS.getParam('max_distance') !== null) {
      this.joinCoordinatesAndGetSearchData(filters, page, sort, notSendTrackingData);
    } else {
      this.getSearchData(filters, page, sort, notSendTrackingData);
    }
  }

  getSearchData(filters, page, sort, notSendTrackingData) {
    this.stockApiService.getSearchData({filters, page, sort}).then((value: SearchModel)  => {
      this.advancedFilters = value.advancedFilters;
      this.result = value.result;
      this.resultListLoading = false;

      this.result.list = this.labelProviderService.fillOfferLabelsByArray(this.result.list);

      if (this.initOfferCount === 'init') {
        this.initOfferCount = value.result.list.length;
      } else if (this.initOfferCount === 0 && value.result.list.length > 0) {
        this.initOfferCount = value.result.list.length;
      }

      const adobeFilters =
          'model:' + (filters.model || '') + '|' +
          'fuel:' + (filters.fuelType || '') + '|' +
          'priceF:' + (filters.priceFrom || '') + '|' +
          'priceT:' + (filters.priceTo || '') + '|' +
          'location:' + (filters.longitude ? $('input[name="location"]').val() : '') + '|' +
              'year:' + (this.QSS.getParam('production_year') || '') + '|' +
              'gear:' + (this.QSS.getParam('gearboxType') || '') + '|' +
              'drive:' + (this.QSS.getParam('driveType') || '') + '|' +
              'power-engine:' + (this.QSS.getParam('enginePower_from') || '') + '-' + (this.QSS.getParam('enginePower_to') || '') + '|' +
              'color:' + (this.QSS.getParam('color') || '') + '|' +
              'interior:' + (this.QSS.getParam('interior_type') || '') + '|' +
              'optional:' + (this.QSS.getParam('equipment') || '') + '|' +
              'km:' + (this.QSS.getParam('mileage') || '');

      if (!notSendTrackingData && ((new Date().getTime() - this.pageLoadTime) > 1500)) {
        this.adobeService.loadedSearchResults(adobeFilters, value.result.info.countOfResults);
      }


      if ((filters.model || null) !== this.bk_lastModel) {
        let dealer = null;
        if (filters.dealer && /^\d{7}$/.test(filters.dealer)) {
          if (this.result.info.dealerNames && Object.keys(this.result.info.dealerNames).length > 0) {
            dealer = this.result.info.dealerNames[Object.keys(this.result.info.dealerNames)[0]];
          }
        }
          this.blueKaiService.changeRoute(filters.model, dealer);
          this.bk_lastModel = filters.model;
      }

      let dealerName = null;
      if (filters.dealer && /^\d{7}$/.test(filters.dealer)) {
        if (this.result.info.dealerNames && Object.keys(this.result.info.dealerNames).length > 0) {
          dealerName = this.result.info.dealerNames[Object.keys(this.result.info.dealerNames)[0]];
        }
      }

      this.titleService.setTitleList(filters.model, dealerName);
    }).catch(reason => {
      ErrorHandler.handle(reason);
    });
  }

  async joinCoordinatesAndGetSearchData(filters, page, sort, notSendTrackingData) {
    const geocoder = new google.maps.Geocoder();

    await geocoder.geocode({placeId: this.QSS.getParam('place_id')}, (results) => {
      filters.lat = results[0].geometry.location.lat();
      filters.lng = results[0].geometry.location.lng();

      this.getSearchData(filters, page, sort, notSendTrackingData);
    });
  }

  getFilters() {

    let productionYear = this.QSS.getParam('production_year');
    if (productionYear !== null) {
      productionYear = productionYear.toString().split(':;');
    }

    let gearboxType = this.QSS.getParam('gearboxType');
    if (gearboxType !== null) {
      gearboxType = gearboxType.toString().split(':;');
    }

    let driveType = this.QSS.getParam('driveType');
    if (driveType !== null) {
      driveType = driveType.toString().split(':;');
    }

    let color = this.QSS.getParam('color');
    if (color !== null) {
      color = color.toString().split(':;');
    }

    let interiorType = this.QSS.getParam('interior_type');
    if (interiorType !== null) {
      interiorType = interiorType.toString().split(':;');
    }

    let equipment = this.QSS.getParam('equipment');
    if (equipment !== null) {
      equipment = equipment.toString().split(':;');
    }

    let label = this.QSS.getParam('label');
    if (label !== null) {
      label = label.toString().split(':;');
    }

    let financialProductsUrl = this.QSS.getParam('promoFinancialProductsOnly');
    let financialProducts = false;
    if (financialProductsUrl !== null) {
      financialProductsUrl = financialProductsUrl.toString();
      if (financialProductsUrl === 'true') {
        financialProducts = true;
      }
    }

    return {
      dealer: this.dealerCode,
      model: this.QSS.getParam('models'),
      version: this.QSS.getParam('version'),
      maxLength: this.QSS.getParam('maxLength'),
      maxHeight: this.QSS.getParam('maxHeight'),
      fuelType: this.QSS.getParam('fuelType'),
      priceFrom: this.QSS.getParam('price_from'),
      priceTo: this.QSS.getParam('price_to'),
      mileage: this.QSS.getParam('mileage'),
      maxDistance: this.QSS.getParam('max_distance'),
      lat: null,
      lng: null,
      productionYear: productionYear,
      gearboxType: gearboxType,
      driveType: driveType,
      enginePowerFrom: this.QSS.getParam('enginePower_from'),
      enginePowerTo: this.QSS.getParam('enginePower_to'),
      color: color,
      interiorType: interiorType,
      equipment: equipment,
      label: label,
      promoFinancialProductsOnly: financialProducts,
    };
  }

  beforeFilterUpdate() {
    this.resultListLoading = true;
  }

  filtersVisibleEvent() {
    this.openedFilters = !this.openedFilters;
  }

  pageChange(val: number) {
    this.pageChangeOnly(val);
    this.onFilterUpdate(true);
  }

  pageChangeOnly(val: number) {
    this.page = val;
    this.QSS.setParam('page', val);
  }

  sortChange(val: string) {
    this.sort = val;
    this.QSS.setParam('sort', val);
    this.page = 1;
    this.QSS.setParam('page', 1);
    this.onFilterUpdate(true);
  }
}
